// import { useState } from "react";
// import { BASE_URL } from "../constants";

// export default function LoginScreen({ onLogin }) {
//   const [mobile, setMobile] = useState("919266424809");
//   const [mpin,   setMpin]   = useState("1234");
//   const [loading, setLoading] = useState(false);
//   const [error,   setError]   = useState("");

//   const handleLogin = async () => {
//     if (!mobile.trim() || !mpin.trim()) {
//       setError("Please enter mobile number and MPIN.");
//       return;
//     }
//     setLoading(true);
//     setError("");
//     try {
//       const res  = await fetch(`${BASE_URL}/user/login-with-mpin`, {
//         method:  "POST",
//         headers: { "Content-Type": "application/json" },
//         body:    JSON.stringify({ mobile, mPIN: mpin }),
//       });
//       const data = await res.json();
//       if (data.token) {
//         onLogin(data.token, data.user);
//       } else {
//         setError(data.message || "Login failed. Please check your credentials.");
//       }
//     } catch {
//       setError("Network error. Please check your connection.");
//     }
//     setLoading(false);
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") handleLogin();
//   };

//   return (
//     <div style={{
//       minHeight: "100vh",
//       background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)",
//       display: "flex", alignItems: "center", justifyContent: "center",
//       fontFamily: "'DM Sans', sans-serif", padding: 16, position: "relative",
//       overflow: "hidden",
//     }}>
//       {/* Background decoration */}
//       <div style={{
//         position: "absolute", width: 600, height: 600,
//         background: "radial-gradient(circle, rgba(16,185,129,0.07) 0%, transparent 70%)",
//         top: "50%", left: "50%", transform: "translate(-50%, -50%)",
//         pointerEvents: "none",
//       }} />

//       <div style={{
//         background: "rgba(255,255,255,0.04)", backdropFilter: "blur(20px)",
//         border: "1px solid rgba(255,255,255,0.08)", borderRadius: 24,
//         padding: "48px 40px", width: "100%", maxWidth: 420,
//         animation: "fadeUp 0.5s ease", position: "relative",
//       }}>
//         {/* Logo */}
//         <div style={{ textAlign: "center", marginBottom: 40 }}>
//           <div style={{
//             width: 60, height: 60,
//             background: "linear-gradient(135deg, #10b981, #059669)",
//             borderRadius: 18, display: "flex", alignItems: "center",
//             justifyContent: "center", margin: "0 auto 20px", fontSize: 26,
//             boxShadow: "0 8px 24px rgba(16,185,129,0.35)",
//           }}>💼</div>
//           <h1 style={{
//             color: "#fff", margin: "0 0 8px", fontSize: 28,
//             fontFamily: "'Playfair Display', serif", letterSpacing: "-0.5px",
//           }}>JobPortal Agent</h1>
//           <p style={{ color: "#64748b", margin: 0, fontSize: 14 }}>
//             Sign in to manage your job listings
//           </p>
//         </div>

//         {/* Mobile */}
//         <div style={{ marginBottom: 16 }}>
//           <label style={{
//             color: "#94a3b8", fontSize: 11, fontWeight: 700,
//             display: "block", marginBottom: 8, letterSpacing: "0.08em", textTransform: "uppercase",
//           }}>Mobile Number</label>
//           <input
//             value={mobile}
//             onChange={e => setMobile(e.target.value)}
//             onKeyDown={handleKeyDown}
//             placeholder="91XXXXXXXXXX"
//             style={{
//               width: "100%", padding: "13px 16px",
//               background: "rgba(255,255,255,0.06)",
//               border: "1.5px solid rgba(255,255,255,0.1)",
//               borderRadius: 12, color: "#fff", fontSize: 15,
//               outline: "none", fontFamily: "'DM Sans', sans-serif",
//               transition: "border-color 0.2s", boxSizing: "border-box",
//             }}
//             onFocus={e => (e.target.style.borderColor = "rgba(16,185,129,0.5)")}
//             onBlur={e =>  (e.target.style.borderColor = "rgba(255,255,255,0.1)")}
//           />
//         </div>

//         {/* MPIN */}
//         <div style={{ marginBottom: 28 }}>
//           <label style={{
//             color: "#94a3b8", fontSize: 11, fontWeight: 700,
//             display: "block", marginBottom: 8, letterSpacing: "0.08em", textTransform: "uppercase",
//           }}>MPIN</label>
//           <input
//             type="password"
//             value={mpin}
//             onChange={e => setMpin(e.target.value)}
//             onKeyDown={handleKeyDown}
//             placeholder="Enter your MPIN"
//             style={{
//               width: "100%", padding: "13px 16px",
//               background: "rgba(255,255,255,0.06)",
//               border: "1.5px solid rgba(255,255,255,0.1)",
//               borderRadius: 12, color: "#fff", fontSize: 15,
//               outline: "none", fontFamily: "'DM Sans', sans-serif",
//               transition: "border-color 0.2s", boxSizing: "border-box",
//             }}
//             onFocus={e => (e.target.style.borderColor = "rgba(16,185,129,0.5)")}
//             onBlur={e =>  (e.target.style.borderColor = "rgba(255,255,255,0.1)")}
//           />
//         </div>

//         {/* Error */}
//         {error && (
//           <div style={{
//             background: "rgba(239,68,68,0.12)", border: "1px solid rgba(239,68,68,0.25)",
//             color: "#fca5a5", padding: "11px 14px", borderRadius: 10,
//             fontSize: 13, marginBottom: 20, lineHeight: 1.5,
//           }}>⚠ {error}</div>
//         )}

//         {/* Submit */}
//         <button
//           onClick={handleLogin}
//           disabled={loading}
//           style={{
//             width: "100%", padding: "14px",
//             background: loading ? "rgba(16,185,129,0.5)" : "linear-gradient(135deg, #10b981, #059669)",
//             border: "none", borderRadius: 12, color: "#fff", fontSize: 15, fontWeight: 700,
//             cursor: loading ? "not-allowed" : "pointer",
//             fontFamily: "'DM Sans', sans-serif", transition: "opacity 0.2s",
//             boxShadow: loading ? "none" : "0 4px 20px rgba(16,185,129,0.4)",
//           }}
//         >
//           {loading ? "Signing in…" : "Sign In →"}
//         </button>

//         <p style={{ color: "#334155", fontSize: 12, textAlign: "center", marginTop: 24 }}>
//           RasuTrip Websoft Technologies LLP
//         </p>
//       </div>
//     </div>
//   );
// }
import { useState } from "react";
import { BASE_URL } from "../constants";

export default function LoginScreen({ onLogin }) {
  const [mobile, setMobile] = useState("");
  const [mpin,   setMpin]   = useState("");
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");

  const handleLogin = async () => {
    if (mobile.trim().length !== 10 || !/^\d{10}$/.test(mobile.trim())) {
      setError("Please enter a valid 10-digit mobile number.");
      return;
    }
    if (!mpin.trim()) {
      setError("Please enter your MPIN.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res  = await fetch(`${BASE_URL}/user/login-with-mpin`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ mobile: `91${mobile.trim()}`, mPIN: mpin }),
      });
      const data = await res.json();
      if (data.token) {
        onLogin(data.token, data.user);
      } else {
        setError(data.message || "Login failed. Please check your credentials.");
      }
    } catch {
      setError("Network error. Please check your connection.");
    }
    setLoading(false);
  };

  const handleMobileChange = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 10); // sirf digits, max 10
    setMobile(val);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleLogin();
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "'DM Sans', sans-serif", padding: 16, position: "relative",
      overflow: "hidden",
    }}>
      <div style={{
        position: "absolute", width: 600, height: 600,
        background: "radial-gradient(circle, rgba(16,185,129,0.07) 0%, transparent 70%)",
        top: "50%", left: "50%", transform: "translate(-50%, -50%)",
        pointerEvents: "none",
      }} />

      <div style={{
        background: "rgba(255,255,255,0.04)", backdropFilter: "blur(20px)",
        border: "1px solid rgba(255,255,255,0.08)", borderRadius: 24,
        padding: "48px 40px", width: "100%", maxWidth: 420,
        position: "relative",
      }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <div style={{
            width: 60, height: 60,
            background: "linear-gradient(135deg, #10b981, #059669)",
            borderRadius: 18, display: "flex", alignItems: "center",
            justifyContent: "center", margin: "0 auto 20px", fontSize: 26,
            boxShadow: "0 8px 24px rgba(16,185,129,0.35)",
          }}>💼</div>
          <h1 style={{
            color: "#fff", margin: "0 0 8px", fontSize: 28,
            fontFamily: "'Playfair Display', serif", letterSpacing: "-0.5px",
          }}>JobPortal Agent</h1>
          <p style={{ color: "#64748b", margin: 0, fontSize: 14 }}>
            Sign in to manage your job listings
          </p>
        </div>

        {/* Mobile */}
        <div style={{ marginBottom: 16 }}>
          <label style={{
            color: "#94a3b8", fontSize: 11, fontWeight: 700,
            display: "block", marginBottom: 8, letterSpacing: "0.08em", textTransform: "uppercase",
          }}>Mobile Number</label>
          <div style={{ display: "flex", gap: 0 }}>
            {/* +91 prefix box */}
            <div style={{
              padding: "13px 14px",
              background: "rgba(16,185,129,0.15)",
              border: "1.5px solid rgba(16,185,129,0.3)",
              borderRight: "none",
              borderRadius: "12px 0 0 12px",
              color: "#10b981", fontSize: 15, fontWeight: 700,
              whiteSpace: "nowrap",
            }}>+91</div>
            <input
              value={mobile}
              onChange={handleMobileChange}
              onKeyDown={handleKeyDown}
              placeholder="10-digit number"
              inputMode="numeric"
              style={{
                flex: 1, padding: "13px 16px",
                background: "rgba(255,255,255,0.06)",
                border: "1.5px solid rgba(255,255,255,0.1)",
                borderRadius: "0 12px 12px 0",
                color: "#fff", fontSize: 15,
                outline: "none", fontFamily: "'DM Sans', sans-serif",
                transition: "border-color 0.2s", boxSizing: "border-box",
              }}
              onFocus={e => (e.target.style.borderColor = "rgba(16,185,129,0.5)")}
              onBlur={e =>  (e.target.style.borderColor = "rgba(255,255,255,0.1)")}
            />
          </div>
        </div>

        {/* MPIN */}
        <div style={{ marginBottom: 28 }}>
          <label style={{
            color: "#94a3b8", fontSize: 11, fontWeight: 700,
            display: "block", marginBottom: 8, letterSpacing: "0.08em", textTransform: "uppercase",
          }}>MPIN</label>
          <input
            type="password"
            value={mpin}
            onChange={e => setMpin(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Enter your MPIN"
            style={{
              width: "100%", padding: "13px 16px",
              background: "rgba(255,255,255,0.06)",
              border: "1.5px solid rgba(255,255,255,0.1)",
              borderRadius: 12, color: "#fff", fontSize: 15,
              outline: "none", fontFamily: "'DM Sans', sans-serif",
              transition: "border-color 0.2s", boxSizing: "border-box",
            }}
            onFocus={e => (e.target.style.borderColor = "rgba(16,185,129,0.5)")}
            onBlur={e =>  (e.target.style.borderColor = "rgba(255,255,255,0.1)")}
          />
        </div>

        {/* Error */}
        {error && (
          <div style={{
            background: "rgba(239,68,68,0.12)", border: "1px solid rgba(239,68,68,0.25)",
            color: "#fca5a5", padding: "11px 14px", borderRadius: 10,
            fontSize: 13, marginBottom: 20, lineHeight: 1.5,
          }}>⚠ {error}</div>
        )}

        {/* Submit */}
        <button
          onClick={handleLogin}
          disabled={loading}
          style={{
            width: "100%", padding: "14px",
            background: loading ? "rgba(16,185,129,0.5)" : "linear-gradient(135deg, #10b981, #059669)",
            border: "none", borderRadius: 12, color: "#fff", fontSize: 15, fontWeight: 700,
            cursor: loading ? "not-allowed" : "pointer",
            fontFamily: "'DM Sans', sans-serif", transition: "opacity 0.2s",
            boxShadow: loading ? "none" : "0 4px 20px rgba(16,185,129,0.4)",
          }}
        >
          {loading ? "Signing in…" : "Sign In →"}
        </button>

        <p style={{ color: "#334155", fontSize: 12, textAlign: "center", marginTop: 24 }}>
          RasuTrip Websoft Technologies LLP
        </p>
      </div>
    </div>
  );
}